import { Stack } from '@mui/material';
import React from 'react';

import { OffboardingAlert } from '@/console/features/general-settings/components/offboarding/offboarding-alert/offboarding-alert';
import { NotificationsButton } from '@/console/features/notifications/components/notifications-button/notifications-button';
import { AppVersionRefreshBadge } from '@/shared/features/app-version/components/app-version-refresh-badge/app-version-refresh-badge';
import { Breadcrumbs } from '@/shared/features/header/components/breadcrumbs/breadcrumbs';
import { TrialExpired } from '@/shared/features/header/components/trial-expired/trial-expired';
import { UserMenu } from '@/shared/features/header/components/user-menu/user-menu';
import { HeaderWrapper } from '@/shared/features/header/header.styled';
import { THeaderProps } from '@/shared/features/header/header.types';

export const Header: React.FC<THeaderProps> = ({
  hideBreadcrumbs,
  hideNotifications,
  hideAlerts,
  hideProfileMenuItem,
  hideTrialExpiredBadge,
  additionalItems,
}) => {
  return (
    <HeaderWrapper>
      {!hideBreadcrumbs && <Breadcrumbs />}
      <Stack alignItems="center" direction="row" gap="0.75rem">
        {!hideTrialExpiredBadge && <TrialExpired />}
        {!hideAlerts && <OffboardingAlert />}
        {!hideNotifications && <NotificationsButton />}
        <UserMenu
          hideProfileMenuItem={hideProfileMenuItem}
          additionalItems={additionalItems}
        />
        <AppVersionRefreshBadge />
      </Stack>
    </HeaderWrapper>
  );
};
